import { computed } from "vue";
import { mapState } from "vuex"
import store from '@/store'

export const useMapState = (getKeys:any) => {
	const storeState:any = {}
	const storeFns = mapState(getKeys)

	Object.keys(storeFns).forEach((fnKeys:any) => {
		const fn = storeFns[fnKeys].bind({ $store: store })
		storeState[fnKeys] = computed(fn)
	})
	return storeState
}
export const useModuleMapState = (name:string, getKeys: any) => {
	const storeState: any = {}
	const storeFns = mapState(name, getKeys)
	Object.keys(storeFns).forEach((fnKeys) => {
		const fn = storeFns[fnKeys].bind({$store: store})
		storeState[fnKeys] = computed(fn)
	})
	return storeState
}